(function () {
  'use strict';

  angular.module('app').component('productCostsAndPricesSearch', productCostsAndPricesSearch());

  function productCostsAndPricesSearch() {
    return {
      bindings: {
        showCosts: '=',
        showPrices: '=',
        onSeasonSelected: '&',
        defaultLanguage: '<',
        userLanguageCode: '<',
      },
      controller: ProductCostsAndPricesSearchComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/costs-and-prices/components/product-costs-and-prices-search/product-costs-and-prices-search.component.html',
    };
  }

  ProductCostsAndPricesSearchComponent.$inject = [
    'CONFIGURATIONS',

    // Angular downgraded service
    'seasonService',
    'seasonModalService',
  ];

  function ProductCostsAndPricesSearchComponent(
    config,

    // Angular downgraded service
    seasonService,
    seasonModalService
  ) {
    const vm = this;

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;

    vm.search = {};

    vm.openSeasonsModal = function () {
      let successCallback = function () {
        getSeasons();
      };

      seasonModalService.openSeasonsModal(successCallback);
    };

    vm.selectSeason = function (season) {
      if (vm.seasonSelected && vm.seasonSelected.id === season.id) {
        return;
      }

      vm.seasonSelected = season;

      vm.onSeasonSelected({ season: season });
    };

    vm.$onInit = function () {
      getSeasons();
    };

    // Get active seasons
    function getSeasons() {
      // current, where to is equal or less than today, check utc
      let params = {
        get: 'current',
        // lang: vm.defaultLanguage,
        lang: vm.userLanguageCode,
        skip_check_role: true,
      };

      vm.loadingSeasons = true;
      seasonService.getSeasons(params).subscribe((response) => {
        vm.seasons = response.filter((season) => season.name); // In case of empty translation

        if (vm.seasons.length > 0) {
          let currentSeason = vm.seasons[0];

          vm.search.season_id = currentSeason.id;

          vm.selectSeason(currentSeason);
        }

        vm.loadingSeasons = false;
      });
    }
  }
})();
